import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
export default {
  name: "addSwiper",
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      form: {
        id: "",
        name: "",
        hign_img: "",
        hide_img: "",
        describe: "",
        url: "",
        platform_type: "",
        is_open: "",
        language: ""
      },
      dialogShow: false,
      hign_img: [],
      hide_img: [],
      rules: {
        // sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        name: [{
          required: true,
          message: "请输入名字",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        // describe: [{ required: true, message: "请输入", trigger: "blur" }],
        hign_img: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }],
        hide_img: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }],
        is_open: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        platform_type: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.form = _objectSpread({}, data);
                  _this['hign_img'] = data.hign_img ? [data.hign_img] : [];
                  _this['hide_img'] = data.hide_img ? [data.hide_img] : [];
                  _this.form.describe = _this.$utils.textRepl(data.describe);
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e, type) {
      this[type] = e;
      this.form[type] = e[0] && e[0].response ? e[0].response.data : '';
    },
    onEditorChange: function onEditorChange(e) {
      this.form.describe = e;
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: type ? this.form.id : "",
        name: "",
        hign_img: "",
        hide_img: "",
        describe: "",
        url: "",
        is_open: "",
        language: "",
        platform_type: ""
      };
      this.hign_img = [], this.hide_img = [], this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          data.describe = data.describe.replaceAll(_this2.$imgUrl, '');

          if (data.describe == '<p><br></p>') {
            data.describe = '';
          }

          var reqFn = _this2.form.id ? 'roleBannerUpdate' : 'roleBannnerAdd';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.hide();

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};